var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFilter = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Filter_2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Filter_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter_2",
    "data-name": "Filter \\u2013 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_3_",
    "data-name": "filter (3)",
    transform: "translate(-63 -78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12648",
    "data-name": "Path 12648",
    d: "M93.282,82.864H75.292a3.71,3.71,0,0,0-7.035,0H65.448a1.181,1.181,0,0,0,0,2.362h2.808a3.71,3.71,0,0,0,7.035,0h17.99a1.181,1.181,0,1,0,0-2.362Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12649",
    "data-name": "Path 12649",
    d: "M93.282,211.4H90.474a3.71,3.71,0,0,0-7.035,0H65.448a1.181,1.181,0,0,0,0,2.362h17.99a3.71,3.71,0,0,0,7.035,0h2.808a1.181,1.181,0,1,0,0-2.362Z",
    transform: "translate(0 -118.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12650",
    "data-name": "Path 12650",
    d: "M93.282,339.93H80.353a3.71,3.71,0,0,0-7.035,0H65.448a1.181,1.181,0,1,0,0,2.362h7.869a3.71,3.71,0,0,0,7.035,0h12.93a1.181,1.181,0,1,0,0-2.362Z",
    transform: "translate(0 -236.823)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.759724a2.svg";
export { ForwardRef as ReactComponent };